const ImpairmentAlertsToday = ({alerts}) => {
  return (
    <div className='alerts-section'>
      <div className='alerts-container'>
        <h2>Impairment Alerts Today</h2>
        <div className='alerts-items-container'>
          {alerts.length > 0 ? (
            alerts.map((alert, index) => (
              <div key={index} className='alert-item'>
                <div className='alert-name'>{alert.name}</div>
                <div className='alert-status'>{alert.company}</div>
              </div>
            ))
          ) : (
            <div className='no-alerts'>No alerts today</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImpairmentAlertsToday;
